// extracted by mini-css-extract-plugin
export default {"container":"VendorName_container__P5-mF","container2":"VendorName_container2__3IqLb"};